module.exports = __webpack_public_path__ + "img/noPeopleIn.1b0e4630.png";